export enum LivePollsView {
  LIST,
  GRID,
}
